import { ViewContainerRef, Renderer2, AfterViewInit, Component, ViewEncapsulation, Optional, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { State, StateChangeEvent } from './list-view-header.interface';

@Component({
    selector: '[dh-list-view-header]',
    template: '<div class="column-header"><ng-content></ng-content></div>',
    styleUrls: ['./list-view-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    outputs: ['stateChange'],
    host: {
        class: 'list-view-header',
        '(click)': 'onClick()',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListViewHeaderComponent implements AfterViewInit {
  constructor(
    private _host: ViewContainerRef,
    private renderer: Renderer2
  ) {
    Object.defineProperty(this, '_pointer', { enumerable: false, writable: true });
    Object.defineProperty(this, '_state', { enumerable: false, writable: true });
  }

  private _pointer: any;
  private _state: State = State.DEFAULT;
  private _columnHeader: any;
  @Input('dh-list-view-header') id: number;
  @Input() canSort: boolean;
  stateChange: EventEmitter<StateChangeEvent> = new EventEmitter();

  updateState() {
    if (this._state !== State.DEFAULT) this.stateChange.emit(new StateChangeEvent(this.id, this._state));
  }

  private _changeState(newValue: State) {
    switch (newValue) {
      case State.ORDERBYASC:
        this.renderer.addClass(this._pointer, 'asc');
        this.renderer.addClass(this._host.element.nativeElement, 'highlighted-column');
        break;

      case State.ORDERBYDESC:
        this.renderer.removeClass(this._pointer, 'asc');
        this.renderer.addClass(this._pointer, 'desc');
        this.renderer.addClass(this._host.element.nativeElement, 'highlighted-column');
        break;

      default:
        this.renderer.removeClass(this._pointer, 'asc');
        this.renderer.removeClass(this._pointer, 'desc');
        this.renderer.removeClass(this._host.element.nativeElement, 'highlighted-column');
        break;
    }
  }

  ngAfterViewInit() {
    this._pointer = this.renderer.createElement('span');
    this._columnHeader = this._host.element.nativeElement.firstElementChild;
    if (this.canSort) {
      this.renderer.addClass(this._pointer, 'pointer');
    }
    this.renderer.appendChild(this._columnHeader, this._pointer);
  }

  onClick() {
    if (!this.canSort) {
      return;
    }
    this._state += 1;
    if (this._state > State.ORDERBYDESC) {
      this._state = State.DEFAULT;
    }

    this._changeState(this._state);
    this.stateChange.emit(new StateChangeEvent(this.id, this._state));
  }

  toDefault() {
    this._state = State.DEFAULT;
    this._changeState(this._state);
  }
}
